export const getPageNameFromPath = (pathname = '') => {
  const normalizedPath = pathname.toLowerCase().replace(/^\/render[^/]*/, '');
  if (normalizedPath.includes('/b/') || normalizedPath.includes('/s/')) {
    return 'plp';
  }

  if (normalizedPath.includes('/pep/')) {
    return 'pep';
  }

  // Default fallback
  return 'unknown';
};
export const validateSearchVars = (data, pageType) => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const isServer = typeof window === 'undefined';
  // Common validation logic
  const requiredVariablesProps = [
    'additionalSearchParams',
    'channel',
    'filter',
    'isBrandPricingPolicyCompliant',
    'orderBy',
    'pageSize',
    'storefilter',
    'startIndex',
    'storeId'
  ];

  // Common validation logic
  const requiredVariablesToValidate = (pageType === 'pep' || pageType === '/b') ? [
    ...requiredVariablesProps,
    'navParam'
  ] : [
    ...requiredVariablesProps,
    'keyword'
  ];

  // Check variables object and its required props
  const variables = data;
  if (
    !variables
    || typeof variables !== 'object'
    || !requiredVariablesToValidate.every((prop) => prop in variables)
  ) {
    return false;
  }

  const additionalSearchParams = variables.additionalSearchParams;

  // Check additionalSearchParams exists and has multiStoreIds array
  if (
    !additionalSearchParams
    || typeof additionalSearchParams !== 'object'
    || !Array.isArray(additionalSearchParams.multiStoreIds)
  ) {
    return false;
  }

  // Client-side only: check for additional props in additionalSearchParams
  if (!isServer) {
    const requiredClientProps = ['sponsored', 'mcvisId', 'deliveryZip'];
    if (!requiredClientProps.every((prop) => prop in additionalSearchParams)) {
      return false;
    }
  }

  return true;
};

const NTT_PREFIX = '/Ntt-';

export const isNIncluded = (value) => {
  return (value ?? '').includes('N-');
};

export const getPathName = (path) => {
  if (path.split('?')[0]) {
    return path.split('?')[0];
  }
  return path;
};

export const validateNValue = (slug) => {
  const slugValue = slug ?? '';
  return slugValue.includes('N-');
};

export const isRefinedPage = (path) => {
  return (path ?? '').includes(NTT_PREFIX) || false;
};

export function hasNonEmptySearchModel(obj) {
  return !!obj
  && typeof obj === 'object'
  && Object.keys(obj).length > 0
  && !!obj.searchModel
  && typeof obj.searchModel === 'object'
  && Object.keys(obj.searchModel).length > 0
  && obj.searchModel !== null;
}

export function getFirstNonEmptyObject(obj1, obj2) {
  if (hasNonEmptySearchModel(obj1)) {
    return obj1;
  }
  if (hasNonEmptySearchModel(obj2)) {
    return obj2;
  }
  return null;
}

export const shouldDisplayResultsAppliedOuter = (ctx = {}) => {
  return !ctx?.isDynamicBrandPage;
};

export const shouldDisplayResultsAppliedInner = (ctx = {}) => {
  return !!ctx?.isDynamicBrandPage;
};

export const isDeepEqual = (objA, objB) => {
  // Strict equality check first
  if (objA === objB) return true;

  // Handle null values explicitly (since typeof null === 'object')
  if (objA === null || objB === null) return objA === objB;

  // If either is not an object, compare directly
  if (typeof objA !== 'object' || typeof objB !== 'object') return objA === objB;

  // Handle arrays
  if (Array.isArray(objA) && Array.isArray(objB)) {
    if (objA.length !== objB.length) return false;
    return objA.every((item, index) => isDeepEqual(item, objB[index]));
  }

  // If one is array and other is not, they're not equal
  if (Array.isArray(objA) || Array.isArray(objB)) return false;

  const objAKeys = Object.keys(objA);
  const objBKeys = Object.keys(objB);

  if (objAKeys.length !== objBKeys.length) return false;

  const keysMatch = objAKeys.every((key) => {
    if (!objBKeys.includes(key)) return false;

    const objAValue = objA[key];
    const objBValue = objB[key];

    // Recursive comparison for nested objects
    return isDeepEqual(objAValue, objBValue);
  });

  return keysMatch;
};
